import { API_CONFIG } from './constants.js'

/**
 * JSONP 请求封装
 */
export function jsonp(url, data = {}, callbackName = 'callback') {
  return new Promise((resolve, reject) => {
    const fnName = `jsonp_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`

    const params = new URLSearchParams()
    params.append(callbackName, fnName)
    Object.keys(data).forEach(key => {
      params.append(key, data[key])
    })

    const script = document.createElement('script')
    script.src = `${url}?${params.toString()}`

    const timeout = setTimeout(() => {
      delete window[fnName]
      if (script.parentNode) {
        document.body.removeChild(script)
      }
      reject(new Error('JSONP request timeout'))
    }, 10000)

    window[fnName] = (response) => {
      clearTimeout(timeout)
      delete window[fnName]
      if (script.parentNode) {
        document.body.removeChild(script)
      }
      resolve(response)
    }

    script.onerror = () => {
      clearTimeout(timeout)
      delete window[fnName]
      if (script.parentNode) {
        document.body.removeChild(script)
      }
      reject(new Error('JSONP request failed'))
    }

    document.body.appendChild(script)
  })
}

/**
 * POST 请求封装
 */
export async function post(url, data = {}) {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    body: JSON.stringify(data),
    credentials: 'include',
    mode: 'cors'
  })
  return await response.json()
}

/**
 * API 封装
 */
export const api = {
  async loginCheck() {
    return jsonp(API_CONFIG.loginCheck)
  },

  async userLogin(username, password, expiration = 'None') {
    const loginData = JSON.stringify({
      username,
      password,
      checkcode: '',
      expiration
    })
    return jsonp(API_CONFIG.userLogin, { logindata: loginData })
  },

  async userLogout() {
    return jsonp(API_CONFIG.userLogout)
  },

  async verifyExpiration(userId, modifitime, isRemoveCookie) {
    return jsonp(API_CONFIG.verifyExpiration, { userId, modifitime, isRemoveCookie })
  },

  async getNotifyCount() {
    return jsonp(API_CONFIG.getNotifyCount)
  },

  async setReadAll() {
    return jsonp(API_CONFIG.setReadAll)
  },

  async getCaptcha(clientUid) {
    return post(API_CONFIG.captchaGet, {
      captchaType: 'blockPuzzle',
      clientUid,
      ts: Date.now()
    })
  },

  async checkCaptcha(data) {
    return post(API_CONFIG.captchaCheck, data)
  },

  async sendMessage(phone, token, ts) {
    return post(API_CONFIG.sendMessage, { phone, token, ts })
  },

  async smsRegister(phone, code) {
    return post(API_CONFIG.smsRegister, { phone, code })
  },

  async getHotSearchWords() {
    const response = await fetch('https://www.gamersky.com/autoinc/allsite/v1/search_hot.htm')
    return await response.text()
  }
}